module.exports = __webpack_public_path__ + "svg/ein.735d394.svg";